<div *ngIf="show">
  <div class="visible-lg visible-md" id="overlay-large"></div>
  <div class="visible-sm visible-xs" id="overlay-small"></div>
</div>